import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

interface SidebarContextData {
  open: boolean;
  toggle: () => void;
  setOpen: (value: boolean) => void;
}

const STORAGE_KEY = "vw-cms:sidebar-open";

const SidebarContext = createContext<SidebarContextData>({
  open: true,
  toggle: () => {},
  setOpen: () => {},
});

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [open, setOpenState] = useState<boolean>(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored === null) return true;
      return stored === "true";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(open));
    } catch {
      // ignore
    }
  }, [open]);

  const setOpen = useCallback((value: boolean) => setOpenState(value), []);
  const toggle = useCallback(() => setOpenState((v) => !v), []);

  return (
    <SidebarContext.Provider value={{ open, toggle, setOpen }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}
